import React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Box, Divider } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { borderRadius } from '@mui/system';

const styles = {
  appBar: {
    backgroundColor: '#7091e6',
    color: 'white',
    marginBottom: '24px',
    borderRadius: '10px'
  },
  toolbar: {
    minHeight: '80px',
    gap: '24px',
    paddingLeft: '24px',
    paddingRight: '24px'
  },
  backButton: {
    color: 'white',
    // paddingRight: '24px',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      transform: 'translateX(-2px)'
    }
  },
  divider: {
    borderColor: 'rgba(255, 255, 255, 0.2)',
    borderRightWidth: 2
  },
  contentBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
    height: 48,
    borderRadius: '8px',
    backgroundColor: 'rgba(255, 255, 255, 0.15)'
  },
  icon: {
    fontSize: 28,
    color: 'white'
  },
  title: {
    fontWeight: 600,
    letterSpacing: '0.5px',
    color: 'white'
  }
};

const FormHeader = ({ title, icon: Icon, onBack }) => {
  return (
    <AppBar 
      position="static" 
      elevation={2}
      sx={styles.appBar}
    >
      <Toolbar sx={styles.toolbar}>
        <IconButton
          edge="start"
          onClick={onBack}
          sx={styles.backButton}
        >
          <ArrowBackIosIcon sx={{ fontSize: 32 }} />
        </IconButton>
        
        <Divider 
          orientation="vertical" 
          flexItem 
          sx={styles.divider}
        />
        
        <Box sx={styles.contentBox}>
          {Icon && (
            <Box sx={styles.iconBox}>
              <Icon sx={styles.icon} />
            </Box>
          )}
          <Typography 
            variant="h4" 
            component="h1"
            sx={styles.title}
          >
            {title}
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default FormHeader;